module.exports = __webpack_public_path__ + "static/media/logo.3ca05336.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Images/logo.jpg
// module id = 185
// module chunks = 0